'use client';

import React from 'react';
import { Typography } from '../../../../components';
import { useTranslations } from '../../../../contexts/translation.context';
import { EarnData } from '../types';

interface FansCellProps {
  data: EarnData;
}

const FansCell: React.FC<FansCellProps> = ({ data }) => {
  const { t } = useTranslations();

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-1">
        <Typography variant="body3" className="text-auth-muted">
          {t('partner.revshare.income.table.subscribed')}:
        </Typography>
        <Typography variant="body3" className="text-dark font-medium">
          {data.total_subscribers}
        </Typography>
      </div>
    </div>
  );
};

export default FansCell;
